import { getResourceFromCms } from '@namespace/helpers';

export const getBatchConfigFromCMS = ({ route, options }) =>
  getResourceFromCms(`/batch${route}`, options);
